import { Grid, Row, Column } from 'carbon-components-react'

Grid.Row = Row
Grid.Column = Column

export { Grid, Row, Column, Grid as default }
